import { SearchResponse } from '@algolia/client-search'

export function transformAlgoliaResponse<T>(res: SearchResponse<T>) {
    return res.hits.map(h => {
        const { _highlightResult, ...rest } = h
        return {
            ...rest,
            id: h.objectID,
        }
    })
}
